export default __webpack_public_path__ + "static/media/heirs-icons-instagram.757c8e70.svg";